module.exports = __webpack_public_path__ + "static/media/exitModalMobile-2x.f4b3a4c7.png";